import { InnerContainer, StickyContainer } from './styled';
export function TableActionsContainer(props) {
    const { children, show = false, sticky = false, stretch = false } = props;
    return (<StickyContainer $show={show} $sticky={sticky}>
      <InnerContainer $stretch={stretch}>{children}</InnerContainer>
    </StickyContainer>);
}
